import { SET_ADDRESS_DETAILS } from '../constants'

export const setAddressDetails = payload => (
  {
    type: SET_ADDRESS_DETAILS,
    payload,
  }
)



// WEBPACK FOOTER //
// ./src/containers/Cart/Address/actions.js